export const prefLocation = {
  rexmonster: [
    {
      text: "Bengaluru / Bangalore",
      id: "67bfdcae-92cb-4783-bf40-37f639e57710",
    },
    {
      text: "Hyderabad / Secunderabad, Telangana",
      id: "72da2468-1cbc-4a9a-863a-89e2cfd6502f",
    },
    { text: "Pune", id: "0fb3f865-7da3-424a-8f14-a0d9db705ec1" },
    { text: "Chennai", id: "b2b9a668-5339-4ea8-8b02-2f7e1a582556" },
    { text: "Delhi", id: "b555ca75-7697-462f-a57d-64b42fb98b49" },
  ],
  monstergulf: [
    { text: "Dubai", id: "d59226bb-f506-43bb-9346-431082d83c86" },
    {
      text: "United Arab Emirates",
      id: "a828a702-e8cf-41f5-a994-c367a23dc66c",
    },
    { text: "Abu Dhabi", id: "d84dad3e-3554-439b-bffb-b874126c2d83" },
    { text: "Qatar", id: "532c9090-4070-4b33-9d8e-2b40d4206890" },
    { text: "Cairo", id: "965fd70b-d6df-41e4-a081-c8ecb8c7ce5b" },
  ],
  monstersingapore: [
    { text: "Singapore", id: "c65af7b5-5fda-42e0-984d-4fa38e8284b1" },
    { text: "Abohar", id: "0e52b9b8-edec-44d8-96a8-9e45711b0678" },
    { text: "Malaysia", id: "3a47de7e-14ab-46df-bb02-4230ecb7cca3" },
    { text: "Canada", id: "e8d496f8-8f74-47dd-aee0-ca84a6865f21" },
    { text: "Australia", id: "356448f6-5183-471e-8338-25fab4a29edf" },
  ],
  monsterthailand: [
    { text: "Bangkok Area", id: "21a6c505-a945-4be6-946f-6f640fcbcdf3" },
    { text: "Thailand", id: "1aee52d9-5e7e-4d40-8f1e-8ec1ec6b121f" },
    { text: "Phuket", id: "e730fa5d-8c59-436c-9ddd-17e847bae159" },
    { text: "Rayong", id: "18c9456d-6fff-4a0a-91bd-a818a8a3faf8" },
    { text: "Chiang Mai", id: "8e374f0d-fd66-4df7-9399-c216ffe6c9ae" },
  ],
  monsterphilippines: [
    { text: "Philippines", id: "9ffe9456-654e-4fb9-9b8c-5b0994904264" },
    {
      text: "Metro Manila / NCR",
      id: "af98b9c3-d7a0-435d-bcd9-06b8fee0a0be",
    },
    { text: "Quezon City", id: "0de1c598-f251-4130-932c-430534c6f808" },
    { text: "Cebu City", id: "42411de7-d419-4840-b01e-797334f44bce" },
    { text: "Makati City", id: "e1d353a9-d1bf-4eec-9049-36f9b596ada3" },
  ],
  monstervietnam: [
    { text: "Ho Chi Minh", id: "76362b15-3b35-11e9-a89e-70106fbef856" },
    { text: "Vietnam", id: "33f7ee59-3b35-11e9-a89e-70106fbef856" },
    { text: "Hanoi", id: "d4b99e6c-cc85-4ede-b358-8cdd749af22c" },
    { text: "Nha Trang", id: "9a44ae93-b5a9-4678-885a-cd8370182923" },
    { text: "Da Nang", id: "7633c791-3b35-11e9-a89e-70106fbef856" },
  ],
  monstermalaysia: [
    { text: "Kuala Lumpur", id: "40f5f05f-06e0-482c-8f06-bc53a79bcb13" },
    { text: "Selangor", id: "ad1b8e2e-54de-41b7-be32-4634947c01e4" },
    { text: "Malaysia", id: "3a47de7e-14ab-46df-bb02-4230ecb7cca3" },
    { text: "Penang", id: "4e3d97fa-82fd-4453-b216-b742759ccb41" },
    { text: "Shah Alam", id: "735945c4-07bc-44fa-815c-2499946c58e2" },
  ],
  monsterindonesia: [
    { text: "Jakarta Raya", id: "8413b3f7-12a1-4ffc-8258-c574a964d85f" },
    { text: "Indonesia", id: "67a662a1-b4e8-44aa-ac70-22e653afc1bb" },
    { text: "Surabaya", id: "9042bbf0-769e-41e8-a6c2-f9f8ab722d7d" },
    { text: "Bandung", id: "ccf57a13-0e2b-4f11-beaa-8fc5675669ef" },
    { text: "Bali", id: "40819ce5-0384-4e68-9276-77b6b6f2c80b" },
  ],
  monsterhongkong: [
    { text: "Hong Kong", id: "75c8409f-3b36-11e9-a89e-70106fbef856" },
    { text: "China", id: "d8684458-3b14-42d7-9180-f95ee285d3d1" },
    { text: "Shanghai", id: "edcb3451-34ad-43f8-8ae5-8f1416f19b3d" },
    { text: "Beijing", id: "1cf1db90-331f-427a-a302-242baa9b8822" },
    { text: "Kowloon", id: "11b37341-46cb-11ec-96c9-0022486e8c2d" },
  ],
};
